import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import {
  GetAccessTokensRequest,
  SafeAccessTokenResponse,
} from '@agilelab/plugin-wb-service-accounts-common';
import { QUERY_KEY_ACCESS_TOKENS } from '../constants';
import { accessTokenApiRef } from '../plugin';

export interface UseGetAccessTokensParams {
  accountRef: string;
  enabled?: boolean;
  alertOnError?: boolean;
}

export const useGetAccessTokens = (params: UseGetAccessTokensParams) => {
  const { accountRef, enabled = true, alertOnError = true } = params;
  const alertApi = useApi(customAlertApiRef);
  const accessTokenApi = useApi(accessTokenApiRef);

  const getAccessTokens = async (
    request: GetAccessTokensRequest,
  ): Promise<SafeAccessTokenResponse[]> => {
    return accessTokenApi.getAccessTokens(request);
  };

  return useQuery({
    queryKey: [QUERY_KEY_ACCESS_TOKENS, accountRef],
    queryFn: () => getAccessTokens({ accountRef }),
    enabled: enabled && !!accountRef,
    onError: (error: Error) => {
      if (!alertOnError) return;
      alertApi.post({
        severity: 'error',
        message: error.message || 'Failed to fetch access tokens',
      });
    },
  });
};
